<template>
  <section class="admin">
    <b-container>
      <b-row>
        <b-col cols="12" md="6" lg="3">
          <div class="logo">Админ-панель</div>
        </b-col>
        <b-col cols="12" md="6" lg="3">
          <nav class="nav">
            <router-link to="/">На главную</router-link>
          </nav>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" lg="8" v-if="commissionRates.BTC">
          <div class="box">
            <b-container>
              <b-row>
                <b-col cols="12">
                  <h3>Настройка комиссий</h3>
                </b-col>
                <b-col cols="12" md="6">
                  <div class="wrap">
                    <h3>BTC</h3>
                    <button class="btn btn__icon" @click="edit.BTC = !edit.BTC">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        version="1.1"
                        id="Capa_1"
                        x="0px"
                        y="0px"
                        viewBox="0 0 477.873 477.873"
                        style="enable-background:new 0 0 477.873 477.873;"
                        xml:space="preserve"
                        width="512px"
                        height="512px"
                        class
                      >
                        <g>
                          <g>
                            <g>
                              <path
                                d="M392.533,238.937c-9.426,0-17.067,7.641-17.067,17.067V426.67c0,9.426-7.641,17.067-17.067,17.067H51.2    c-9.426,0-17.067-7.641-17.067-17.067V85.337c0-9.426,7.641-17.067,17.067-17.067H256c9.426,0,17.067-7.641,17.067-17.067    S265.426,34.137,256,34.137H51.2C22.923,34.137,0,57.06,0,85.337V426.67c0,28.277,22.923,51.2,51.2,51.2h307.2    c28.277,0,51.2-22.923,51.2-51.2V256.003C409.6,246.578,401.959,238.937,392.533,238.937z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M458.742,19.142c-12.254-12.256-28.875-19.14-46.206-19.138c-17.341-0.05-33.979,6.846-46.199,19.149L141.534,243.937    c-1.865,1.879-3.272,4.163-4.113,6.673l-34.133,102.4c-2.979,8.943,1.856,18.607,10.799,21.585    c1.735,0.578,3.552,0.873,5.38,0.875c1.832-0.003,3.653-0.297,5.393-0.87l102.4-34.133c2.515-0.84,4.8-2.254,6.673-4.13    l224.802-224.802C484.25,86.023,484.253,44.657,458.742,19.142z M434.603,87.419L212.736,309.286l-66.287,22.135l22.067-66.202    L390.468,43.353c12.202-12.178,31.967-12.158,44.145,0.044c5.817,5.829,9.095,13.72,9.12,21.955    C443.754,73.631,440.467,81.575,434.603,87.419z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </button>
                  </div>
                  <div class="settings-label">
                    <p class="settings-label_name">Отдаете (покупка)</p>
                    <p class="settings-label_number">{{commissionRates.BTC.buy}}%</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="edit.BTC"
                      v-model.number="changedCommissionRates.BTC.buy"
                    />
                  </transition>
                  <div class="settings-label">
                    <p class="settings-label_name">Получаете (продажа)</p>
                    <p class="settings-label_number">{{commissionRates.BTC.sell}}%</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="edit.BTC"
                      v-model.number="changedCommissionRates.BTC.sell"
                    />
                  </transition>
                  <div class="wrap">
                    <h3>ETH</h3>
                    <button class="btn btn__icon" @click="edit.ETH = !edit.ETH">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        version="1.1"
                        id="Capa_1"
                        x="0px"
                        y="0px"
                        viewBox="0 0 477.873 477.873"
                        style="enable-background:new 0 0 477.873 477.873;"
                        xml:space="preserve"
                        width="512px"
                        height="512px"
                        class
                      >
                        <g>
                          <g>
                            <g>
                              <path
                                d="M392.533,238.937c-9.426,0-17.067,7.641-17.067,17.067V426.67c0,9.426-7.641,17.067-17.067,17.067H51.2    c-9.426,0-17.067-7.641-17.067-17.067V85.337c0-9.426,7.641-17.067,17.067-17.067H256c9.426,0,17.067-7.641,17.067-17.067    S265.426,34.137,256,34.137H51.2C22.923,34.137,0,57.06,0,85.337V426.67c0,28.277,22.923,51.2,51.2,51.2h307.2    c28.277,0,51.2-22.923,51.2-51.2V256.003C409.6,246.578,401.959,238.937,392.533,238.937z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M458.742,19.142c-12.254-12.256-28.875-19.14-46.206-19.138c-17.341-0.05-33.979,6.846-46.199,19.149L141.534,243.937    c-1.865,1.879-3.272,4.163-4.113,6.673l-34.133,102.4c-2.979,8.943,1.856,18.607,10.799,21.585    c1.735,0.578,3.552,0.873,5.38,0.875c1.832-0.003,3.653-0.297,5.393-0.87l102.4-34.133c2.515-0.84,4.8-2.254,6.673-4.13    l224.802-224.802C484.25,86.023,484.253,44.657,458.742,19.142z M434.603,87.419L212.736,309.286l-66.287,22.135l22.067-66.202    L390.468,43.353c12.202-12.178,31.967-12.158,44.145,0.044c5.817,5.829,9.095,13.72,9.12,21.955    C443.754,73.631,440.467,81.575,434.603,87.419z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </button>
                  </div>
                  <div class="settings-label">
                    <p class="settings-label_name">Отдаете (покупка)</p>
                    <p class="settings-label_number">{{commissionRates.ETH.buy}}%</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="edit.ETH"
                      v-model.number="changedCommissionRates.ETH.buy"
                    />
                  </transition>
                  <div class="settings-label">
                    <p class="settings-label_name">Получаете (продажа)</p>
                    <p class="settings-label_number">{{commissionRates.ETH.sell}}%</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="edit.ETH"
                      v-model.number="changedCommissionRates.ETH.sell"
                    />
                  </transition>
                  <div class="wrap">
                    <h3>USDT</h3>
                    <button class="btn btn__icon" @click="edit.USDT = !edit.USDT">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        version="1.1"
                        id="Capa_1"
                        x="0px"
                        y="0px"
                        viewBox="0 0 477.873 477.873"
                        style="enable-background:new 0 0 477.873 477.873;"
                        xml:space="preserve"
                        width="512px"
                        height="512px"
                        class
                      >
                        <g>
                          <g>
                            <g>
                              <path
                                d="M392.533,238.937c-9.426,0-17.067,7.641-17.067,17.067V426.67c0,9.426-7.641,17.067-17.067,17.067H51.2    c-9.426,0-17.067-7.641-17.067-17.067V85.337c0-9.426,7.641-17.067,17.067-17.067H256c9.426,0,17.067-7.641,17.067-17.067    S265.426,34.137,256,34.137H51.2C22.923,34.137,0,57.06,0,85.337V426.67c0,28.277,22.923,51.2,51.2,51.2h307.2    c28.277,0,51.2-22.923,51.2-51.2V256.003C409.6,246.578,401.959,238.937,392.533,238.937z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M458.742,19.142c-12.254-12.256-28.875-19.14-46.206-19.138c-17.341-0.05-33.979,6.846-46.199,19.149L141.534,243.937    c-1.865,1.879-3.272,4.163-4.113,6.673l-34.133,102.4c-2.979,8.943,1.856,18.607,10.799,21.585    c1.735,0.578,3.552,0.873,5.38,0.875c1.832-0.003,3.653-0.297,5.393-0.87l102.4-34.133c2.515-0.84,4.8-2.254,6.673-4.13    l224.802-224.802C484.25,86.023,484.253,44.657,458.742,19.142z M434.603,87.419L212.736,309.286l-66.287,22.135l22.067-66.202    L390.468,43.353c12.202-12.178,31.967-12.158,44.145,0.044c5.817,5.829,9.095,13.72,9.12,21.955    C443.754,73.631,440.467,81.575,434.603,87.419z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </button>
                  </div>
                  <div class="settings-label">
                    <p class="settings-label_name">Отдаете (покупка)</p>
                    <p class="settings-label_number">{{commissionRates.USDT.buy}}%</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="edit.USDT"
                      v-model.number="changedCommissionRates.USDT.buy"
                    />
                  </transition>
                  <div class="settings-label">
                    <p class="settings-label_name">Получаете (продажа)</p>
                    <p class="settings-label_number">{{commissionRates.USDT.sell}}%</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="edit.USDT"
                      v-model.number="changedCommissionRates.USDT.sell"
                    />
                  </transition>
                </b-col>
                <b-col cols="12" md="6">
                  <div class="wrap">
                    <h3>USD</h3>
                    <button class="btn btn__icon" @click="edit.USD = !edit.USD">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        version="1.1"
                        id="Capa_1"
                        x="0px"
                        y="0px"
                        viewBox="0 0 477.873 477.873"
                        style="enable-background:new 0 0 477.873 477.873;"
                        xml:space="preserve"
                        width="512px"
                        height="512px"
                        class
                      >
                        <g>
                          <g>
                            <g>
                              <path
                                d="M392.533,238.937c-9.426,0-17.067,7.641-17.067,17.067V426.67c0,9.426-7.641,17.067-17.067,17.067H51.2    c-9.426,0-17.067-7.641-17.067-17.067V85.337c0-9.426,7.641-17.067,17.067-17.067H256c9.426,0,17.067-7.641,17.067-17.067    S265.426,34.137,256,34.137H51.2C22.923,34.137,0,57.06,0,85.337V426.67c0,28.277,22.923,51.2,51.2,51.2h307.2    c28.277,0,51.2-22.923,51.2-51.2V256.003C409.6,246.578,401.959,238.937,392.533,238.937z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M458.742,19.142c-12.254-12.256-28.875-19.14-46.206-19.138c-17.341-0.05-33.979,6.846-46.199,19.149L141.534,243.937    c-1.865,1.879-3.272,4.163-4.113,6.673l-34.133,102.4c-2.979,8.943,1.856,18.607,10.799,21.585    c1.735,0.578,3.552,0.873,5.38,0.875c1.832-0.003,3.653-0.297,5.393-0.87l102.4-34.133c2.515-0.84,4.8-2.254,6.673-4.13    l224.802-224.802C484.25,86.023,484.253,44.657,458.742,19.142z M434.603,87.419L212.736,309.286l-66.287,22.135l22.067-66.202    L390.468,43.353c12.202-12.178,31.967-12.158,44.145,0.044c5.817,5.829,9.095,13.72,9.12,21.955    C443.754,73.631,440.467,81.575,434.603,87.419z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </button>
                  </div>
                  <div class="settings-label">
                    <p class="settings-label_name">Отдаете (покупка)</p>
                    <p class="settings-label_number">{{commissionRates.USD.buy}}%</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="edit.USD"
                      v-model.number="changedCommissionRates.USD.buy"
                    />
                  </transition>
                  <div class="settings-label">
                    <p class="settings-label_name">Получаете (продажа)</p>
                    <p class="settings-label_number">{{commissionRates.USD.sell}}%</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="edit.USD"
                      v-model.number="changedCommissionRates.USD.sell"
                    />
                  </transition>
                  <div class="wrap">
                    <h3>EUR</h3>
                    <button class="btn btn__icon" @click="edit.EUR = !edit.EUR">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        version="1.1"
                        id="Capa_1"
                        x="0px"
                        y="0px"
                        viewBox="0 0 477.873 477.873"
                        style="enable-background:new 0 0 477.873 477.873;"
                        xml:space="preserve"
                        width="512px"
                        height="512px"
                        class
                      >
                        <g>
                          <g>
                            <g>
                              <path
                                d="M392.533,238.937c-9.426,0-17.067,7.641-17.067,17.067V426.67c0,9.426-7.641,17.067-17.067,17.067H51.2    c-9.426,0-17.067-7.641-17.067-17.067V85.337c0-9.426,7.641-17.067,17.067-17.067H256c9.426,0,17.067-7.641,17.067-17.067    S265.426,34.137,256,34.137H51.2C22.923,34.137,0,57.06,0,85.337V426.67c0,28.277,22.923,51.2,51.2,51.2h307.2    c28.277,0,51.2-22.923,51.2-51.2V256.003C409.6,246.578,401.959,238.937,392.533,238.937z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M458.742,19.142c-12.254-12.256-28.875-19.14-46.206-19.138c-17.341-0.05-33.979,6.846-46.199,19.149L141.534,243.937    c-1.865,1.879-3.272,4.163-4.113,6.673l-34.133,102.4c-2.979,8.943,1.856,18.607,10.799,21.585    c1.735,0.578,3.552,0.873,5.38,0.875c1.832-0.003,3.653-0.297,5.393-0.87l102.4-34.133c2.515-0.84,4.8-2.254,6.673-4.13    l224.802-224.802C484.25,86.023,484.253,44.657,458.742,19.142z M434.603,87.419L212.736,309.286l-66.287,22.135l22.067-66.202    L390.468,43.353c12.202-12.178,31.967-12.158,44.145,0.044c5.817,5.829,9.095,13.72,9.12,21.955    C443.754,73.631,440.467,81.575,434.603,87.419z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </button>
                  </div>
                  <div class="settings-label">
                    <p class="settings-label_name">Отдаете (покупка)</p>
                    <p class="settings-label_number">{{commissionRates.EUR.buy}}%</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="edit.EUR"
                      v-model.number="changedCommissionRates.EUR.buy"
                    />
                  </transition>
                  <div class="settings-label">
                    <p class="settings-label_name">Получаете (продажа)</p>
                    <p class="settings-label_number">{{commissionRates.EUR.sell}}%</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="edit.EUR"
                      v-model.number="changedCommissionRates.EUR.sell"
                    />
                  </transition>
                  <div class="wrap">
                    <h3>UAH</h3>
                    <button class="btn btn__icon" @click="edit.UAH = !edit.UAH">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        version="1.1"
                        id="Capa_1"
                        x="0px"
                        y="0px"
                        viewBox="0 0 477.873 477.873"
                        style="enable-background:new 0 0 477.873 477.873;"
                        xml:space="preserve"
                        width="512px"
                        height="512px"
                        class
                      >
                        <g>
                          <g>
                            <g>
                              <path
                                d="M392.533,238.937c-9.426,0-17.067,7.641-17.067,17.067V426.67c0,9.426-7.641,17.067-17.067,17.067H51.2    c-9.426,0-17.067-7.641-17.067-17.067V85.337c0-9.426,7.641-17.067,17.067-17.067H256c9.426,0,17.067-7.641,17.067-17.067    S265.426,34.137,256,34.137H51.2C22.923,34.137,0,57.06,0,85.337V426.67c0,28.277,22.923,51.2,51.2,51.2h307.2    c28.277,0,51.2-22.923,51.2-51.2V256.003C409.6,246.578,401.959,238.937,392.533,238.937z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M458.742,19.142c-12.254-12.256-28.875-19.14-46.206-19.138c-17.341-0.05-33.979,6.846-46.199,19.149L141.534,243.937    c-1.865,1.879-3.272,4.163-4.113,6.673l-34.133,102.4c-2.979,8.943,1.856,18.607,10.799,21.585    c1.735,0.578,3.552,0.873,5.38,0.875c1.832-0.003,3.653-0.297,5.393-0.87l102.4-34.133c2.515-0.84,4.8-2.254,6.673-4.13    l224.802-224.802C484.25,86.023,484.253,44.657,458.742,19.142z M434.603,87.419L212.736,309.286l-66.287,22.135l22.067-66.202    L390.468,43.353c12.202-12.178,31.967-12.158,44.145,0.044c5.817,5.829,9.095,13.72,9.12,21.955    C443.754,73.631,440.467,81.575,434.603,87.419z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </button>
                  </div>
                  <div class="settings-label">
                    <p class="settings-label_name">Отдаете (покупка)</p>
                    <p class="settings-label_number">{{commissionRates.UAH.buy}}%</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="edit.UAH"
                      v-model.number="changedCommissionRates.UAH.buy"
                    />
                  </transition>
                  <div class="settings-label">
                    <p class="settings-label_name">Получаете (продажа)</p>
                    <p class="settings-label_number">{{commissionRates.UAH.sell}}%</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="edit.UAH"
                      v-model.number="changedCommissionRates.UAH.sell"
                    />
                  </transition>
                </b-col>
                <b-col cols="12" md="6" offset-md="3">
                  <button class="btn btn__succes" @click="changeCommissionRates">Сохранить</button>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </b-col>
        <b-col cols="12" lg="8" v-if="fiatRates.USD">
          <div class="box">
            <b-container>
              <b-row>
                <b-col cols="12">
                  <h3>Настройки курсов</h3>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" md="6">
                  <div class="wrap">
                    <h3>USD</h3>
                    <button class="btn btn__icon" @click="fiatEdit.USD = !fiatEdit.USD">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        version="1.1"
                        id="Capa_1"
                        x="0px"
                        y="0px"
                        viewBox="0 0 477.873 477.873"
                        style="enable-background:new 0 0 477.873 477.873;"
                        xml:space="preserve"
                        width="512px"
                        height="512px"
                        class
                      >
                        <g>
                          <g>
                            <g>
                              <path
                                d="M392.533,238.937c-9.426,0-17.067,7.641-17.067,17.067V426.67c0,9.426-7.641,17.067-17.067,17.067H51.2    c-9.426,0-17.067-7.641-17.067-17.067V85.337c0-9.426,7.641-17.067,17.067-17.067H256c9.426,0,17.067-7.641,17.067-17.067    S265.426,34.137,256,34.137H51.2C22.923,34.137,0,57.06,0,85.337V426.67c0,28.277,22.923,51.2,51.2,51.2h307.2    c28.277,0,51.2-22.923,51.2-51.2V256.003C409.6,246.578,401.959,238.937,392.533,238.937z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M458.742,19.142c-12.254-12.256-28.875-19.14-46.206-19.138c-17.341-0.05-33.979,6.846-46.199,19.149L141.534,243.937    c-1.865,1.879-3.272,4.163-4.113,6.673l-34.133,102.4c-2.979,8.943,1.856,18.607,10.799,21.585    c1.735,0.578,3.552,0.873,5.38,0.875c1.832-0.003,3.653-0.297,5.393-0.87l102.4-34.133c2.515-0.84,4.8-2.254,6.673-4.13    l224.802-224.802C484.25,86.023,484.253,44.657,458.742,19.142z M434.603,87.419L212.736,309.286l-66.287,22.135l22.067-66.202    L390.468,43.353c12.202-12.178,31.967-12.158,44.145,0.044c5.817,5.829,9.095,13.72,9.12,21.955    C443.754,73.631,440.467,81.575,434.603,87.419z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </button>
                  </div>
                  <div class="settings-label">
                    <p class="settings-label_name">Покупка</p>
                    <p
                      class="settings-label_number"
                    >EUR {{fiatRates.USD.EUR.buy}} UAH {{fiatRates.USD.UAH.buy}}</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="fiatEdit.USD"
                      v-model.number="changedFiatRates.USD.EUR.buy"
                    />
                  </transition>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="fiatEdit.USD"
                      v-model.number="changedFiatRates.USD.UAH.buy"
                    />
                  </transition>
                  <div class="settings-label">
                    <p class="settings-label_name">Продажа</p>
                    <p
                      class="settings-label_number"
                    >EUR {{fiatRates.USD.EUR.sell}} UAH {{fiatRates.USD.UAH.sell}}</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="fiatEdit.USD"
                      v-model.number="changedFiatRates.USD.EUR.sell"
                    />
                  </transition>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="fiatEdit.USD"
                      v-model.number="changedFiatRates.USD.UAH.sell"
                    />
                  </transition>
                </b-col>
                <b-col cols="12" md="6">
                  <div class="wrap">
                    <h3>EUR</h3>
                  </div>
                  <div class="settings-label">
                    <p class="settings-label_name">Покупка</p>
                    <p
                      class="settings-label_number"
                    >USD {{fiatRates.EUR.USD.buy}} UAH {{fiatRates.EUR.UAH.buy}}</p>
                  </div>
                  <div class="settings-label">
                    <p class="settings-label_name">Продажа</p>
                    <p
                      class="settings-label_number"
                    >USD {{fiatRates.EUR.USD.sell}} UAH {{fiatRates.EUR.UAH.sell}}</p>
                  </div>
                </b-col>
                <b-col cols="12" md="6">
                  <div class="wrap">
                    <h3>UAH</h3>
                  </div>
                  <div class="settings-label">
                    <p class="settings-label_name">Покупка</p>
                    <p
                      class="settings-label_number"
                    >USD {{fiatRates.UAH.USD.buy}} EUR {{fiatRates.UAH.EUR.buy}}</p>
                  </div>
                  <div class="settings-label">
                    <p class="settings-label_name">Продажа</p>
                    <p
                      class="settings-label_number"
                    >USD {{fiatRates.UAH.USD.sell}} EUR {{fiatRates.UAH.EUR.sell}}</p>
                  </div>
                </b-col>
                <b-col cols="12" md="6" offset-md="3">
                  <button class="btn btn__succes" @click="changeFiatRates">Сохранить</button>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
'use strict';
export default {
  data: () => ({
    changeSuccess: false,
    changeFail: false,
    edit: {
      BTC: false,
      ETH: false,
      USDT: false,
      USD: false,
      EUR: false,
      UAH: false
    },
    fiatEdit: {
      USD: false
    }
  }),
  computed: {
    commissionRates() {
      let rates = this.$store.getters.commissionRates;

      for (let rate in rates) {
        rates[rate].buy = parseFloat((rates[rate].buy * 100).toFixed(3));
        rates[rate].sell = parseFloat((rates[rate].sell * 100).toFixed(3));
      }

      return rates;
    },
    fiatRates() {
      return this.$store.getters.fiatRates;
    },
    changedCommissionRates() {
      return JSON.parse(JSON.stringify(this.commissionRates));
    },
    changedFiatRates() {
      return JSON.parse(JSON.stringify(this.fiatRates));
    }
  },
  created: async function() {
    await this.$store.dispatch("getСommissionRates");
    await this.$store.dispatch("getFiatRates");
  },
  methods: {
    clg() {
      console.log(this.fiatRates);
    },
    async changeCommissionRates() {
      let changedCommissionRates = this.changedCommissionRates;

      for (let rate in changedCommissionRates) {
        changedCommissionRates[rate].buy = parseFloat(
          changedCommissionRates[rate].buy / 100
        );
        changedCommissionRates[rate].sell = parseFloat(
          changedCommissionRates[rate].sell / 100
        );
      }

      try {
        this.$store.dispatch("changeСommissionRates", changedCommissionRates);
        this.$store.dispatch("getСommissionRates");
        this.changeSuccess = true;
      } catch (error) {
        this.changeFail = true;
        console.log(error);
      }
    },
    async changeFiatRates() {
      let changedFiatRates = this.changedFiatRates;

      try {
        this.$store.dispatch("changeFiatRates", changedFiatRates);
        this.$store.dispatch("getFiatRates");
        this.changeSuccess = true;
      } catch (error) {
        this.changeFail = true;
        console.log(error);
      }
    }
  }
};
</script>

<style lang='sass'>
.admin
  input
    width: 100%
  .btn__succes
    margin-top: 1rem
  .wrap
    display: flex
    justify-content: flex-start
    align-items: center
    h3
      margin: 0 10px .5rem 0
    .btn
      margin: 0 0 .5rem 0

.settings-label
  width: 100%
  margin-bottom: 1rem
  padding: 0.75rem
  display: flex
  align-items: center
  background-color: #242629
  border-radius: 5px
  p
    margin-bottom: 0
    padding: 0 5px
  &_name
    margin-right: auto
</style>